import type { Locale } from '~/i18n/i18n-config';
import type { CurrencyName } from '~/utils/currency';
import { createCurrencyFormatter } from '~/utils/currency';

export type { CurrencyCookie, CurrencyName } from '~/utils/currency';
export { CURRENCIES, isValidCurrency } from '~/utils/currency';

export function convertPrice(
  amountGBP: number,
  exchangeRate: number,
  locale: Locale,
  currency: CurrencyName,
  showDecimals = false
): string {
  const amount = currency === 'GBP' ? amountGBP : amountGBP * exchangeRate;
  return createCurrencyFormatter(locale, currency, showDecimals).format(amount);
}
